export class BgcVote {
  'Position Id': string = '';
  'Position': string = '';
  'Nominated Person Ids': string[] = [];
}

export class BgcVotingRequest {
  'Group Id': string = '';
  'Email': string = '';
  'SR Number': string = '';
  'Expiry Date': string = '';
  'Votes': BgcVote[] = [];
}
